/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import Cookies from "universal-cookie";
import URL from "./envURLs";
import CONSTANTS from "../constants/constants";

const cookies = new Cookies();
const { NO_AUTH } = CONSTANTS.ERROR_PAGE;

const axiosInstance = axios.create({
  baseURL: URL.API.baseURL,
  headers: {
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = cookies.get("token");
    if (token) {
      // Token is already stored with token_type prefix (e.g., "Bearer eyJ...")
      // from login.tsx: cookies.set("token", `${data?.token_type} ${data?.access_token}`)
      config.headers.Authorization = token;
    }
    // Set Content-Type for POST/PUT/PATCH requests with JSON data
    // Don't set for GET requests or if already set (e.g., multipart/form-data)
    if (
      (config.method === "post" ||
        config.method === "put" ||
        config.method === "patch") &&
      !config.headers["Content-Type"] &&
      !config.headers["content-type"]
    ) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const errorHandler = (error: any) => {
  const { response = "" }: any = error || "";
  const { status } = response;
  const { pathname } = window.location;

  if (status === 401) {
    const loginObject = cookies.get("token");
    if (loginObject) {
      console.log(loginObject);
      if (window.location.search) {
        cookies.set("pathname", pathname + window.location.search, {
          path: "/",
        });
        window.location.replace("/");
        return;
      }
      window.location.replace(NO_AUTH);
      window.location.href = `${window.location.origin}/${NO_AUTH}`;
    }
  }
  return Promise.reject(error);
};

const responseHandler = (response: any) => {
  const { status } = response;
  if (status === 401) {
    window.location.replace(NO_AUTH);
  }
  return response;
};
axiosInstance.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);
export default axiosInstance;
